import { type FC, useId } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { type ContactFormState } from '../../../contact-form'

type Props = {
  formState: ContactFormState
}

export const DirectContactFormNameInputFieldsSection: FC<Props> = ({
  formState,
}) => {
  const intl = useIntl()
  const { model } = formState

  const firstNameId = useId()
  const lastNameId = useId()

  return (
    <div className="mb-2 grid gap-3.5 tablet:grid-cols-2">
      <FormControl
        error={!model.validator.isPropertyValid('firstName')}
        onChange={(event): void => {
          formState.makeInputProps('firstName').onChange(event)
        }}
        required
        value={model.firstName}
      >
        <FormLabel htmlFor={firstNameId}>
          {intl.formatMessage({ id: 'general.label.firstName' })}
        </FormLabel>
        <Input
          id={firstNameId}
          slotProps={{
            input: {
              'data-qa-id': 'message-form-§emailForm.firstName',
            },
          }}
        />
        {model.validator.getFirstErrorFor('firstName') && (
          <FormHelperText data-qa-id="global-MessageForm-firstname-error-msg">
            {model.validator.getFirstErrorFor('firstName')}
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        error={!model.validator.isPropertyValid('lastName')}
        onChange={(event): void => {
          formState.makeInputProps('lastName').onChange(event)
        }}
        required
        value={model.lastName}
      >
        <FormLabel htmlFor={lastNameId}>
          {intl.formatMessage({ id: 'general.label.surname' })}
        </FormLabel>
        <Input
          id={lastNameId}
          slotProps={{
            input: {
              'data-qa-id': 'message-form-§emailForm.lastName',
            },
          }}
        />
        {model.validator.getFirstErrorFor('lastName') && (
          <FormHelperText data-qa-id="global-MessageForm-lastname-error-msg">
            {model.validator.getFirstErrorFor('lastName')}
          </FormHelperText>
        )}
      </FormControl>
    </div>
  )
}
